import { CalendarPrintViewBase } from './CalendarPrintView.base';
import {
    CalendarPrintViewProps,
    CalendarPrintViewStyleProps,
    CalendarPrintViewStyles,
} from './CalendarPrintView.types';
import { styled } from '@fluentui/react/lib/Utilities';

export { CalendarPrintViewProps };

/** The default style of CalendarPrintView */
export function getStyles(styleProps: CalendarPrintViewStyleProps): CalendarPrintViewStyles {
    return {
        root: [
            'ms-CalendarPrintView',
            {
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
            },
            styleProps.className,
        ],
    };
}

/** The default styled version of CalendarPrintView */
export const CalendarPrintView = styled<
    CalendarPrintViewProps<{}>,
    CalendarPrintViewStyleProps,
    CalendarPrintViewStyles
>(CalendarPrintViewBase, getStyles) as typeof CalendarPrintViewBase;
